module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABJ0lEQVRIie2WsUpDMRSGv9tWB1Hq4CAuipsdLO1o3qTZDfgKDl31DcwDBIQ+QR8gq5eLL6ClSzctCOLQODRCe7nWlpsUlZ7p5M855yM5nJDEOYeQugm0iGupNSpLLjp3TeABqEQGToB2henJYsPwjNY6QHNWC1hrADwCW8AusAc0gGpo4AC4tEb18xtC6ifgOCRwBAhr1HDZhLI9vF4FBuVO6IDerCCkPgc6wKGXDkICx9aocU67B84WJYUei6OfAtY+h79+8G+BG++7/KY1av/LF1LvAG9lge/WqJclY0+LxJhXelIkhnxLEVLXgcQvGyGAXSF11/uvsz3z9gzUFxX4/2OxAW6AfwOYMv2kxrYJkNasUZmQus3qX/2PAu0K2P4mPrVGZZ8DJkFalVXEAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = p8ve
// module chunks = 8